/**
 * postback-templates.js
 *
 * Shared postback URL templates per affiliate system.
 * {salid} is replaced at render time with the actual salid value.
 *
 * Keys must match affiliateSystem.name (case-insensitive lookup).
 */

const POSTBACK_TEMPLATES = {
    referon: {
        defaultSalid: 74,
        registerTemplate: 'https://pb.affiliationspace.com?token=f05fe2af&salid={salid}&clickid=${clickid}&campaignId=${pubid}&et=reg',
        ftdTemplate:      'https://pb.affiliationspace.com?token=f05fe2af&salid={salid}&clickid=${clickid}&campaignId=${pubid}&depositValue=${depositValue}&et=ftd',
        depositTemplate:  'https://pb.affiliationspace.com?token=f05fe2af&salid={salid}&clickid=${clickid}&campaignId=${pubid}&depositValue=${depositValue}&et=dep',
    },
    cellxpert: {
        defaultSalid: 91,
        registerTemplate: 'https://pb.affiliationspace.com?token=f05fe2af&salid={salid}&clickId=[afp1]&campaignId=[trackingcode]&et=reg',
        ftdTemplate:      'https://pb.affiliationspace.com?token=f05fe2af&salid={salid}&clickId=[afp1]&campaignId=[trackingcode]&et=ftd',
        depositTemplate:  null,
    },
    myaffiliates: {
        defaultSalid: 34,
        registerTemplate: 'https://pb.affiliationspace.com/?token=f05fe2af&salid={salid}&custId={{customer.id}}&clickId={{s2s.req_id}}&campaignId={{campaign.id}}&campName={{campaign.name}}&et=reg',
        ftdTemplate:      'https://pb.affiliationspace.com/?token=f05fe2af&salid={salid}&custId={{customer.id}}&clickId={{s2s.req_id}}&campaignId={{campaign.id}}&campName={{campaign.name}}&et=ftd',
        depositTemplate:  null,
    },
    softswiss: {
        defaultSalid: 97,
        registerTemplate: 'https://pb.affiliationspace.com?token=f05fe2af&salid={salid}&clickId=${vist_id}&campaignId=${promo_id}&et=reg',
        ftdTemplate:      'https://pb.affiliationspace.com?token=f05fe2af&salid={salid}&clickId=${vist_id}&campaignId=${promo_id}&et=ftd',
        depositTemplate:  null,
    },
    affise: {
        defaultSalid: 37,
        registerTemplate: 'https://pb.affiliationspace.com/?token=f05fe2af&salid={salid}&clickId={sub2}&campaignId={sub1}&et=reg',
        ftdTemplate:      'https://pb.affiliationspace.com/?token=f05fe2af&salid={salid}&clickId={sub2}&campaignId={sub1}&et=ftd',
        depositTemplate:  null,
    },
    netrefer: {
        defaultSalid: 91,
        registerTemplate: 'https://pb.affiliationspace.com?token=f05fe2af&salid={salid}&clickid={clickid}&campaignId={subid}&et=reg',
        ftdTemplate:      'https://pb.affiliationspace.com?token=f05fe2af&salid={salid}&clickid={clickid}&campaignId={subid}&et=ftd',
        depositTemplate:  null,
    },
};

/**
 * @param {string} system — affiliateSystem.name (case-insensitive)
 * @returns {{ defaultSalid, registerTemplate, ftdTemplate, depositTemplate } | null}
 */
export function getPostbackTemplates(system) {
    if (!system) return null;
    return POSTBACK_TEMPLATES[system.toLowerCase()] ?? null;
}
